import React from 'react';
import { BoxIcon } from 'lucide-react';
interface PageHeroProps {
  title: string;
  subtitle?: string;
  icon?: BoxIcon;
}
export function PageHero({
  title,
  subtitle,
  icon: Icon
}: PageHeroProps) {
  return <section className="relative pt-40 pb-20 px-6 overflow-hidden bg-brand-black" data-id="element-114">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-115">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-brand-blue/10 blur-[120px]" data-id="element-116" />
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-brand-cyan/5 blur-[100px]" data-id="element-117" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10 text-center reveal" data-id="element-118">
        {Icon && <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-brand-blue/10 text-brand-blue mb-6 border border-brand-blue/20" data-id="element-119">
            <Icon className="w-8 h-8" data-id="element-120" />
          </div>}
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 tracking-tight" data-id="element-121">
          {title}
        </h1>
        {subtitle && <p className="text-xl text-brand-muted-light max-w-3xl mx-auto leading-relaxed" data-id="element-122">
            {subtitle}
          </p>}
      </div>
    </section>;
}